import Button from '../../../../../../js/components/Button'
import messageResource from '../../../../../../js/messageResource'
import TemplateView from '../../../../../../js/TemplateView'
import {ICalLightboxType} from '../../../constants'

export default class EditFedLightBoxFooter extends TemplateView {
    constructor({
        onSubmitButtonClick = () => {},
        onCancelButtonClick = () => {},
    } = {}) {
        super()

        this.callbacks = {
            onSubmitButtonClick,
            onCancelButtonClick,
        }

        this.state = {
            type: null,
            submitEnabled: false,
            loading: false,
        }

        this.onStatePropertyChanged('type', type => {
            this.submitButton.setState({
                label: messageResource.getMessage(type === ICalLightboxType.CREATE ? 'icalendar.page.lightbox.create.button' : 'common.buttons.save_changes'),
                withPlusIcon: type === ICalLightboxType.CREATE
            })
            this.$submitButtonEl.toggleClass('createButton', type === ICalLightboxType.CREATE)
            this.$submitButtonEl.toggleClass('editButton', type === ICalLightboxType.EDIT)
        })

        this.onStatePropertyChanged('submitEnabled', submitEnabled => this.submitButton.setState({disabled: !submitEnabled}))
        this.onStatePropertyChanged('loading', loading => this.submitButton.setState({loading}))
    }

    templateHtml() {
        return `<div class='basicLightboxFooter'>
                    <div class='buttonsBox'>
                        <div class='submitButton'/>
                        <div class='cancelBtn'>
                            <%=cancelButtonLabel%>
                        </div>
                    </div>
                </div>`
    }

    messageKeys() {
        return {
            cancelButtonLabel: 'common.cancel'
        }
    }

    afterRender() {
        this.$submitButtonEl = this.find('.submitButton')
        this.submitButton = new Button({
            onClickCb: this.callbacks.onSubmitButtonClick,
            withLoading: true,
        }).init(this.$submitButtonEl)

        this.$cancelButtonEl = this.find('.cancelBtn')
    }

    //for compatibility with LightBox
    getCommitBtnEl() {
        return []
    }

    getCancelBtnEl() {
        return this.$cancelButtonEl
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/edit/EditFeedLightboxFooter.js